import { Injectable, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  private readonly titleService = inject(Title);
  private readonly metaService = inject(Meta);

  setTitle(title:string): void {
    this.titleService.setTitle(title);
  }

  addTags(keywords:string, description:string, robots:string): void {
    this.metaService.addTags([
      { name: 'keywords', content: keywords },
      { name: 'description', content: description },
      { name: 'robots', content: robots }
    ]);
  }

  updateTag(tag:string, content:string): void {
    this.metaService.updateTag({ name: tag, content: content });
  }

  setDefaultSeoData(): void {
    this.setTitle('Chronicles of Starr - Front-End Web Developer, Poet, Writer, and Music Producer');
    this.updateTag('keywords', 'Coding, Front-End, Angular, Writing, Poetry, Music, Ambient, Down-Tempo, Trip-Hop');
    this.updateTag('description', 'The works and adventures of S.Tarr.');
    this.updateTag('robots', 'index, follow');
  }
}
